<template>
  <div style="width:1440px;margin:0 auto;height:100%;">
    <div class="block" style="margin-top: 20px;" align="center">
      <div :hidden="iconLoading">
        <i class="el-icon-loading" ></i>
      </div>
      <el-date-picker
        v-model="value5"
        type="datetimerange"
        :picker-options="pickerOptions"
        range-separator="to"
        start-placeholder="start time"
        end-placeholder="end time"
        align="right">
      </el-date-picker>
    </div>
    <el-row>
      <el-col align="center" style="margin-top: 15px;">
        <el-button v-on:click="query1" type="primary" style="background-color: #004499; border-color: #004499" :disabled="disabled">query</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col align="center">
        <!--gridData.slice((currentPage-1)*pageSize,currentPage*pageSize)-->
        <el-table v-loading="pieLoading"
          :data="gridData" style="width: 100%" align="center"
          :row-class-name="tableRowClassName">
          <el-table-column prop="startTime" label="Start Time" width="180" align="center"></el-table-column>
          <el-table-column prop="endTime" label="End Time" width="180" align="center"></el-table-column>
          <el-table-column prop="interval" label="Interval" width="180" align="center"></el-table-column>
          <el-table-column prop="status" label="Status" width="180" align="center"></el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <!--<div align="center">-->
        <!--<span class="demonstration">page select</span>-->
      <!--</div>-->
      <!--<el-pagination-->
        <!--layout="prev, pager, next,jumper"-->
        <!--:page-count="pageNumber"-->
        <!--:current-page.sync="currentPage"-->
        <!--@current-change="pageChange" align="center">-->
      <!--</el-pagination>-->
    </el-row>
  </div>
</template>

<script>
    export default {
        name: "operstatlist",
        data(){
          return {
            iconLoading:true,
            disabled:false,
            pieLoading:false,

            pageNumber:0,
            pageSize:50,
            currentPage:1,

            gridData: [],
            pickerOptions: {
              shortcuts: [{
                text: '最近一天',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24);
                  picker.$emit('pick', [start, end]);
                }
              },{
                text: '最近一周',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近一个月',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                  picker.$emit('pick', [start, end]);
                }
              }, {
                text: '最近三个月',
                onClick(picker) {
                  const end = new Date();
                  const start = new Date();
                  start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                  picker.$emit('pick', [start, end]);
                }
              }]
            },
            value5: [new Date(Date.now()-3600*24*1000), new Date(Date.now())],
          }
        },
      mounted(){
          this.query();
      },
        methods:{
          query1:function(){
            this.query();
          },
          query:function () {
            let date1 = new Date(this.value5[1]);
            let date2 = new Date(this.value5[0]);
            this.disabled = true;
            // this.pieLoading = true;
            this.iconLoading = false;
            let q = new Array();
            let n;
            let _this = this;
            let time1 = date1.format("yyyy-MM-dd hh:mm:ss");
            let time2 = date2.format("yyyy-MM-dd hh:mm:ss");
            let startTime,endTime;
            let status = ["init","ShutDown", "Injection", "BeamAvailable","Tuning"]
            let lastest = null;
           
              this.$axios.get('/hlsTS/history/lastestStatusStatistics/' + time2 + '/' + time1 )
              .then(function (response1) {
                if(response1.status != 200){
                  _this.$notify.error({
                    title: '错误',
                    message: '运行状态数据获取失败' ,
                    position: 'top-right',
                    offset:400
                  });
                  // _this.pieLoading = false
                  _this.disabled = false
                  _this.iconLoading = true
                  return;
                }
                if(response1.data == null || response1.data === "" || response1.data.length === 0) {
                  _this.$notify.error({
                    title: '错误',
                    message: '运行状态数据获取结果为空',
                    position: 'top-right',
                    offset:400
                  });
                  // _this.pieLoading = false
                  _this.disabled = false
                  _this.iconLoading = true
                  return;
                }
                  lastest = response1.data;
                  _this.$axios.get('/hlsTS/history/status/' + time2 + '/' + time1)
                    .then(function (response) {
                      if(response.status != 200){
                        _this.$notify.error({
                          title: '错误',
                          message: "运行状态数据获取失败",
                          position: 'top-right',
                          offset:400
                        });
                        // _this.pieLoading = false
                        _this.disabled = false
                        _this.iconLoading = true
                        return;
                      }
                      if(response.data === null || response.data.length === 0) {
                        q.push({
                          startTime:date2.format("yyyy-MM-dd hh:mm:ss").toString(),
                          endTime:date1.format("yyyy-MM-dd hh:mm:ss").toString(),
                          interval:24.00.toFixed(2),
                          status:status[lastest.num_val]
                        })
                        _this.gridData = q;
                        // _this.pieLoading = false
                        _this.disabled = false
                        _this.iconLoading = true
                        return;
                      }
                      n = response.data.length;
                      _this.pageNumber = Math.ceil(n%_this.pageSize ? n/_this.pageSize : n/_this.pageSize +1);
                      q.push({
                      startTime:date2.format("yyyy-MM-dd hh:mm:ss").toString(),
                      endTime:new Date(parseInt(response.data[0].timestamp.substring(0,13),10)).format("yyyy-MM-dd hh:mm:ss").toString(),
                      interval:((new Date(parseInt(response.data[0].timestamp.substring(0,13),10)) - date2)/(60*60*1000)).toFixed(2),
                      status:status[lastest.num_val]
                    })
                  for (let i = 0; i < n-1; i++){
                    startTime = new Date(parseInt(response.data[i].timestamp.substring(0,13),10));
                    endTime = new Date(parseInt(response.data[i+1].timestamp.substring(0,13),10));
                    q.push({
                      startTime:startTime.format("yyyy-MM-dd hh:mm:ss").toString(),
                      endTime:endTime.format("yyyy-MM-dd hh:mm:ss").toString(),
                      interval:((endTime-startTime)/(60*60*1000)).toFixed(2),
                      status:status[response.data[i].num_val]
                    })
                  }
                  q.push({
                    startTime:new Date(parseInt(response.data[n-1].timestamp.substring(0,13),10)).format("yyyy-MM-dd hh:mm:ss").toString(),
                    endTime:date1.format("yyyy-MM-dd hh:mm:ss").toString(),
                    interval:((date1 - (new Date(parseInt(response.data[n-1].timestamp.substring(0,13),10))))/(60*60*1000)).toFixed(2),
                    status:status[response.data[n-1].num_val]
                  })
                  _this.gridData = q;
                  // _this.pieLoading = false
                  _this.disabled = false
                      _this.iconLoading = true

                      
                    })
              })
            function  calc1(date3) {
              var days=Math.floor(date3/(24*3600*1000))
              let result = "";
              if(days != 0){
                result = result + days + " d "

              }
              //计算出小时数

              var leave1=date3%(24*3600*1000)    //计算天数后剩余的毫秒数
              var hours=Math.floor(leave1/(3600*1000))
              if(hours != 0){
                result = result + hours + " h "
              }
              //计算相差分钟数
              var leave2=leave1%(3600*1000)        //计算小时数后剩余的毫秒数
              var minutes=Math.floor(leave2/(60*1000))
              //计算相差秒数
              if(minutes != 0){
                result = result + minutes + " min "
              }
              var leave3=leave2%(60*1000)      //计算分钟数后剩余的毫秒数
            var seconds=Math.round(leave3/1000)
            var milliseconds = leave3%1000
            if(seconds != 0){
              result = result + seconds + " s "
            }
            if(milliseconds != 0){
              result = result + milliseconds + " ms "
            }
            return result
            }
           
          },
          pageChange:function (val) {
            this.currentPage = val;
          },
          tableRowClassName({row, rowIndex}) {
            if(row.status === 'BeamAvailable'){
              return 'success-row'
            }
            return ''
          }
        }
    }

</script>

<style>
  .el-table .warning-row {
    background: oldlace;
  }

  .el-table .success-row {
    background: #f0f9eb;
  }
</style>



// WEBPACK FOOTER //
// src/page/activePublic/operstatlist.vue